import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_send",
  "use": "svg_send-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_send\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.673.321C.813-.109-.098.802.331 1.661L3.483 7.98H8.97a1 1 0 1 1 0 2H3.504L.33 16.34c-.43.859.483 1.77 1.342 1.34l15.553-7.785a1 1 0 0 0 0-1.788L1.673.32Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol